
import attachInvoiceToPurchaseOrder from './attachInvoiceToPurchaseOrder'
import fetchOrderRelatedSinisters from './fetchOrderRelatedSinisters'
import fetchAdvancesByPurchase from './fetchAdvancesByPurchase'
import deleteInvoiceToPurchaseOrder from './deleteInvoiceToPurchaseOrder'

export {
  attachInvoiceToPurchaseOrder,
  fetchOrderRelatedSinisters,
  fetchAdvancesByPurchase,
  deleteInvoiceToPurchaseOrder
}


// WEBPACK FOOTER //
// ./src/services/purchase/purchaseOrder/index.js